import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, AuthCallback, Protected } from "@/lib/auth";
import Landing from "@/pages/Home";
import GuestPage from "@/pages/GuestPage";
import HostLayout from "@/pages/host/HostLayout";
import Properties from "@/pages/host/Properties";
import PropertyEditor from "@/pages/host/PropertyEditor";
import Contacts from "@/pages/host/Contacts";
import Orders from "@/pages/host/Orders";
import Subscription from "@/pages/host/Subscription";
import Insights from "@/pages/host/Insights";
import Documents from "@/pages/host/Documents";
import Housekeeper from "@/pages/Housekeeper";
import Admin from "@/pages/admin/Admin";
import Feedback from "@/pages/Feedback";
import Login from "@/pages/Login";
import Messages from "@/pages/host/Messages";
import { ForgotPassword, ResetPassword } from "@/pages/ResetPassword";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/sample" element={<GuestPage sample />} />
      <Route path="/p/:slug" element={<GuestPage />} />
      <Route path="/k/:code" element={<GuestPage keyholder />} />
      <Route path="/f/:code" element={<Feedback />} />
      <Route path="/h/:code" element={<Housekeeper />} />
      <Route path="/dashboard" element={<Protected><HostLayout /></Protected>}>
        <Route index element={<Properties />} />
        <Route path="properties/:pid" element={<PropertyEditor />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="orders" element={<Orders />} />
        <Route path="subscription" element={<Subscription />} />
        <Route path="insights" element={<Insights />} />
        <Route path="documents" element={<Documents />} />
        <Route path="messages" element={<Messages />} />
      </Route>
      <Route path="/admin" element={<Protected owner><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}
